import axios from 'axios';
import { showToast } from './components/Toast/toastBridge';

/**
 * Configura interceptador global de axios para adicionar JWT em todas as requisições
 */
export const configureAxios = () => {
  // Interceptador de requisição: adiciona token JWT no header Authorization
  axios.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('token');
      
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Interceptador de resposta: trata erros de autenticação e rate limiting
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      // Rate limiting (429)
      if (error.response && error.response.status === 429) {
        const retryAfter = error.response.data?.retryAfter || error.response.headers['retry-after'] || 60;
        const minutos = Math.ceil(retryAfter / 60);
        const mensagem = retryAfter < 60 
          ? `Você excedeu o limite de requisições. Tente novamente em ${retryAfter} segundos.`
          : `Você excedeu o limite de requisições. Tente novamente em ${minutos} minuto(s).`;
        
        // Telas que ja mostram o bloqueio no proprio fluxo (ex.: dialogo de
        // comando de exaustor) pedem para nao duplicar o aviso
        if (!error.config?.skipRateLimitToast) {
          showToast(mensagem, { type: 'warning' });
        }
        
        // Rejeita com erro customizado para não confundir com erros de lógica
        const customError = new Error(mensagem);
        customError.isRateLimitError = true;
        customError.retryAfter = retryAfter;
        return Promise.reject(customError);
      }
      
      // Autenticação inválida (401)
      if (error.response && error.response.status === 401) {
        // Token expirado ou inválido - limpa localStorage e redireciona para login
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
      
      return Promise.reject(error);
    }
  );
};
